import { Box, Link, ListItem, Text, UnorderedList } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useGenerateQWCFile } from 'hooks/integrations/useGenerateQWCFile';
import { useIntegrationStore } from 'store/useIntegrationStore';
import toaster from 'utils/toaster';

const WebConnector = () => {
  const { mutateAsync: generateQWCAsync } = useGenerateQWCFile();

  const { t } = useTranslation(['integrations']);

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const quickbookDesktopIntegrationData = integrationListData.filter(
    (tab: any) => tab.key === 'quick-books-desktop'
  )[0];

  const quickbookWebConnectUrl =
    'https://developer.intuit.com/app/developer/qbdesktop/docs/get-started/get-started-with-quickbooks-web-connector';

  const onGenerateGWC = () => {
    generateQWCAsync().then(res => {
      const fileName = 'timeero_QBD.qwc';
      const gwcFile = new Blob([res], { type: 'text/plain' });
      const gwcFileUrl = URL.createObjectURL(gwcFile);
      const anchorTag = document.createElement('a');
      anchorTag.setAttribute('href', gwcFileUrl);
      anchorTag.setAttribute('download', fileName);
      anchorTag.dataset.downloadurl = ['text/plain', anchorTag.download, anchorTag.href].join(':');
      anchorTag.draggable = true;
      anchorTag.classList.add('dragout');
      anchorTag.click();
    });
  };

  const copyPassword = (password: string) => {
    navigator.clipboard.writeText(password);
    toaster.info({ description: 'Copied!' });
  };

  return (
    <Box>
      <Box
        boxShadow="0 0 5px 0 #e1e1e1"
        borderRadius="5px"
        padding="10px 20px 20px 20px"
        borderLeft="5px solid"
        borderColor="primary.300"
        mb={6}
      >
        <Text fontSize="md" mb={2}>
          {t('integrations:quickbooksDesktop.webConnectorInstallation')}
        </Text>
        <Text fontSize="sm">{t('integrations:quickbooksDesktop.followStepsWebConnector')}</Text>
      </Box>
      <Box boxShadow="0 0 5px 0 #e1e1e1" borderRadius="5px" padding="10px 20px 20px 20px">
        <UnorderedList>
          <ListItem>
            {t('integrations:quickbooksDesktop.downloadAndInstall')}{' '}
            <Link href={quickbookWebConnectUrl} color="primary.300" display="inline-block" isExternal>
              {t('integrations:quickbooksDesktop.quickbooksWebConnector')}
            </Link>
          </ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.startWebConnector')}</ListItem>
          <ListItem>{t('integrations:quickbooksDesktop.makeSureTimeTracker')}</ListItem>
          <ListItem>
            {t('integrations:quickbooksDesktop.downloadYour')}{' '}
            <Text color="primary.300" display="inline-block" cursor="pointer" onClick={onGenerateGWC}>
              {t('integrations:quickbooksDesktop.webConnectorQWCFile')}
            </Text>
            {t('integrations:quickbooksDesktop.addToWebConnector')}
            <Text
              color="primary.500"
              fontWeight="bolder"
              fontStyle="italic"
              cursor="pointer"
              display="inline-block"
              ml={1}
              onClick={() => copyPassword(quickbookDesktopIntegrationData['password'])}
            >
              {' '}
              {quickbookDesktopIntegrationData['password']}
            </Text>
          </ListItem>
        </UnorderedList>
      </Box>
    </Box>
  );
};
export default WebConnector;
